var map = {
	"./facebook.png": 628,
	"./instagram.png": 4853,
	"./line.png": 7639,
	"./linkedin.png": 2918,
	"./pinterest.png": 9297,
	"./skype.png": 3481,
	"./telegram.png": 2809,
	"./twitter.png": 43,
	"./wechat.png": 5351,
	"./whatsapp.png": 3653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7260;